export default __webpack_public_path__ + "static/media/button-app.891ce87a.png";